import { render, staticRenderFns } from "./add-customers.vue?vue&type=template&id=8f5093ce&scoped=true"
import script from "./add-customers.vue?vue&type=script&lang=js"
export * from "./add-customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5093ce",
  null
  
)

export default component.exports